// import { isNavigationFailure, Router, RouteLocationNormalized } from 'vue-router';
import * as NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css';
NProgress.configure({ showSpinner: true }); // NProgress Configuration

import { message } from 'ant-design-vue';
import {
  LOGIN_NAME,
  whiteNameList
  // defaultRoutePath
} from './constant';
import { generatorDynamicRouter } from './generatorRouter';
import { getMenuForCurrentUser } from '@/api/user';
import basicStorage from '@/utils/basicStorage';
import { userStore } from '@/store/user';
import { TOKEN } from '@/utils/request';

export function createRouterGuards(router) {
  router.beforeEach(async (to, _, next) => {
    // console.log(to);
    NProgress.start();
    //token是否在有效时间内
    let token = basicStorage.getItem(TOKEN);
    // 单点登录功能
    //let queryToken = '';
    if (to.query.token) {
      token = to.query.token;
      // queryToken = token;
      basicStorage.setItem(TOKEN, token);
    }
    //const isInTokenTime = tokenTime(queryToken);&& isInTokenTime
    if (token) {
      if (to.path === '/') {
        next('/layout/welcome');
        return;
      }
      const store = userStore();
      const storeMenu = store.menus;
      if (!storeMenu) {
        try {
          const apiRouter = await getMenuForCurrentUser();
          if (apiRouter?.content) {
            const routerData = apiRouter.content?.filter(v => v.status !== '0' && v.type == 'BACK');
            routerData.forEach(item => {
              if (item.menuType === 0) {
                item.parentId = undefined;
              }
            });
            getBtnPower(apiRouter.content, store);

            const generatorResult = await generatorDynamicRouter([...routerData]);
            store.menus = generatorResult.menus;
            const hasRoute = router.hasRoute(to.name);
            if (!hasRoute) {
              // 如果该路由不存在，可能是动态注册的路由，它还没准备好，需要再重定向一次到该路由
              next({ ...to, replace: true });
            } else {
              next();
            }
          } else {
            message.warning('您的帐号没有配置菜单权限，请联系管理员。', 5);
          }
        } catch (error) {
          console.log(error);
          const generatorResult = await generatorDynamicRouter([]);
          store.menus = generatorResult.menus;
          const hasRoute = router.hasRoute(to.name);
          if (!hasRoute) {
            next({ ...to, replace: true });
          } else {
            next();
          }
        }
      } else {
        next();
      }
    } else {
      if (whiteNameList.some(n => n === to.name)) {
        // 在免登录名单，直接进入
        next();
      } else {
        if (basicStorage.getItem('token-time')) {
          basicStorage.removeItem('token');
        }
        next({ name: LOGIN_NAME, query: { redirect: to.fullPath }, replace: true });
      }
    }
  });
  router.afterEach(() => {
    NProgress.done();
  });

  router.onError(error => {
    console.log('路由错误:', error);
  });
}
const getBtnPower = (data, store) => {
  const btnData = data.filter(v => v.menuType === 2);
  const btnPower = [];
  btnData.forEach(v => {
    btnPower.push(v.perms);
  });
  store.btnPower = btnPower;
};
